"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyUserFields$ = exports.PropertyUserFields$outboundSchema = exports.PropertyUserFields$inboundSchema = exports.PropertyUserFields = void 0;
const z = __importStar(require("zod"));
exports.PropertyUserFields = {
    Address: "address",
    AirportNoise: "airport_noise",
    Assets: "assets",
    CoastalErosion: "coastal_erosion",
    Connectivity: "connectivity",
    ConstructionAgeBand: "construction_age_band",
    ConstructionMaterials: "construction_materials",
    CouncilTax: "council_tax",
    DistanceFromPoint: "distance_from_point",
    Education: "education",
    EnergyPerformance: "energy_performance",
    EstimatedRentalValues: "estimated_rental_values",
    EstimatedValue: "estimated_value",
    EstimatedValueRounded: "estimated_value_rounded",
    EstimatedValues: "estimated_values",
    FloodRisk: "flood_risk",
    Hmo: "hmo",
    Identities: "identities",
    InternalAreaSquareMetres: "internal_area_square_metres",
    IsBungalow: "is_bungalow",
    IsOnTheMarket: "is_on_the_market",
    LatestTransactionDate: "latest_transaction_date",
    ListedBuildingsOnPlot: "listed_buildings_on_plot",
    Localities: "localities",
    Location: "location",
    MarketStatistics: "market_statistics",
    NearbyCompletedTransactions: "nearby_completed_transactions",
    NearbyListedBuildings: "nearby_listed_buildings",
    NearbyListings: "nearby_listings",
    NearbyPlanningApplications: "nearby_planning_applications",
    NumberOfBathrooms: "number_of_bathrooms",
    NumberOfBedrooms: "number_of_bedrooms",
    Occupancy: "occupancy",
    OutdoorSpace: "outdoor_space",
    Ownership: "ownership",
    PlanningApplications: "planning_applications",
    Plot: "plot",
    PropensityToLetScore: "propensity_to_let_score",
    PropensityToSellScore: "propensity_to_sell_score",
    PropertyListings: "property_listings",
    PropertyType: "property_type",
    RestrictiveCovenants: "restrictive_covenants",
    RightOfWay: "right_of_way",
    RadonRiskLevel: "radon_risk_level",
    NearbyScheduledMonuments: "nearby_scheduled_monuments",
    StreetGroupPropertyId: "street_group_property_id",
    StreetView: "street_view",
    Tenure: "tenure",
    TitleDeeds: "title_deeds",
    Transactions: "transactions",
    Transport: "transport",
    Utilities: "utilities",
    YearBuilt: "year_built",
};
/** @internal */
exports.PropertyUserFields$inboundSchema = z.nativeEnum(exports.PropertyUserFields);
/** @internal */
exports.PropertyUserFields$outboundSchema = exports.PropertyUserFields$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertyUserFields$;
(function (PropertyUserFields$) {
    /** @deprecated use `PropertyUserFields$inboundSchema` instead. */
    PropertyUserFields$.inboundSchema = exports.PropertyUserFields$inboundSchema;
    /** @deprecated use `PropertyUserFields$outboundSchema` instead. */
    PropertyUserFields$.outboundSchema = exports.PropertyUserFields$outboundSchema;
})(PropertyUserFields$ || (exports.PropertyUserFields$ = PropertyUserFields$ = {}));
//# sourceMappingURL=propertyuserfields.js.map